export default {"src":"/_next/static/media/blue_check_icon.9a28a1e6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};